<pagination-template #p="paginationApi" (pageChange)="pageChange.emit($event)"
  class="pagination flex justify-between items-center py-8">
  @if (prevPageURL !== undefined && p.pages.length > 1) {
    <a [attr.aria-disabled]="p.isFirstPage()" [href]="[prevPageURL]"
      (click)="p.previous()"
      [ngStyle]="{'pointer-events':  p.isFirstPage() ? 'none' : 'auto', 'opacity':  p.isFirstPage() ? '0.5' : '1'}"
      class="uppercase font-display no-underline text-black text-22px">
      <i class="fa fa-long-arrow-alt-left text-blue"></i>
      <span>Previous</span>
    </a>
  } @else {
    @if (p.pages.length > 1) {
      <button [disabled]="p.isFirstPage()"
        [ngStyle]="{'cursor':  p.isFirstPage() ? 'default' : 'pointer'}"
        class="uppercase font-display no-underline text-black text-22px" (click)="p.previous()">
        <i class="fa fa-long-arrow-alt-left text-blue"></i> <span>Previous</span>
      </button>
    }
  }

  <div class="xs:block sm:block md:block lg:hidden">
    {{ currentPage }} of {{ totalPages ? totalPages : 1 }}
  </div>

  @if (p.pages.length > 1) {
    <div class="pagination__numbers hidden lg:block">
      @for (page of p.pages; track page) {
        <span [class.current]="p.getCurrent() === page.value">
          @if (currentRouteURL !== undefined) {
            <span>
              @if (p.getCurrent() !== page.value) {
                <a [href]="[getPaginationString(page)]" (click)="p.setCurrent(page.value)"
                  [attr.aria-label]="p.getCurrent() == 1 && page.value == 2 ? ('Go to page ' + page.value) : (p.getCurrent() - 1) == page.value ? 'Go to previous page ' + page.value : (p.getCurrent() + 1) == page.value ? 'Go to Next page ' + page.value : 'Go to page ' + page.value"
                  class="no-underline">
                  <span class="no-underline text-grey-dark">{{ page.label }}</span>
                </a>
              } @else {
                <strong>{{ page.label }}</strong>
              }
            </span>
          } @else {
            @if (p.getCurrent() !== page.value) {
              <a (click)="p.setCurrent(page.value)"
                class="no-underline">
                <span class="no-underline text-grey-dark">{{ page.label }}</span>
              </a>
            } @else {
              <strong>{{ page.label }}</strong>
            }
          }
        </span>
      }
    </div>
  }

  @if (nextPageURL !== undefined && p.pages.length > 1) {
    <a [attr.aria-disabled]="p.isLastPage()" [href]="[nextPageURL]" (click)="p.next()"
      [ngStyle]="{'pointer-events':  p.isLastPage() ? 'none' : 'auto', 'opacity':  p.isLastPage() ? '0.5' : '1'}"
      class="uppercase font-display no-underline text-black text-22px"><span> Next</span>
      <i class="fa fa-long-arrow-alt-right text-blue"></i>
    </a>
  } @else {
    @if (p.pages.length > 1) {
      <button [disabled]="p.isLastPage()"
        [ngStyle]="{'cursor':  p.isLastPage() ? 'default' : 'pointer'}"
        class="uppercase font-display no-underline text-black text-22px" (click)="p.next()"><span>
      Next</span>
      <i class="fa fa-long-arrow-alt-right text-blue"></i>
    </button>
  }
}

</pagination-template>